var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('hr'),_vm._v(" "),_c('b-container',{staticClass:"bv-example-row mt-4"},[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" SmartBilling")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388a1db6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AppFooter.vue
// module id = 363
// module chunks = 0